export default class extends Controller {
  static targets = ['input'];

  removeField(event) {
    this.hasInputTarget && this.inputTarget.remove();
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/campaigns/audience-challenge-row-controller.js